module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "autor-nome-table",
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "autor-nome",
    staticStyle: {
      "line-height": "100%",
      "font-size": "25px"
    }
  }, [_vm._v(_vm._s(_vm.autor.nome))]), _vm._v(" "), _c('td', {
    staticClass: "autor-instituicao",
    attrs: {
      "valign": "bottom",
      "align": "right",
      "width": "40%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trabalhos',
        params: {
          pesquisa: _vm.autor.instituicao
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.autor.instituicao))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "autor-infos"
  }, [_c('div', {
    staticClass: "autor-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.autor.todos_trabalhos.length))]), _vm._v(" " + _vm._s(_vm.$tc('publicacao', _vm.autor.todos_trabalhos.length)))]), _vm._v(" "), _c('div', {
    staticClass: "autor-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.autor.eixos.length))]), _vm._v(" " + _vm._s(_vm.$tc('eixo_tematico', _vm.autor.eixos.length)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$tc('trabalho', 2)) + " "), _c('small', [_vm._v("(" + _vm._s(Object.keys(_vm.autor.todos_trabalhos).length) + ")")])]), _vm._v(" "), _vm._l((_vm.autor.todos_trabalhos), function(t) {
    return _c('anais-trabalho-row', {
      key: t.id,
      attrs: {
        "trabalho_id": t.id
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 eixos"
  }, [_c('h1', {
    attrs: {
      "id": "eixos-title"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('eixos_publicados'))) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.autor.eixos.length) + ")")])]), _vm._v(" "), _vm._l((_vm.autor.eixos), function(e) {
    return _c('div', {
      staticClass: "eixo"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: e.nome
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(e.nome) + "\n        ")])], 1)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57724486","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisAutor.vue
// module id = 214
// module chunks = 0